import cn from 'classnames';
import Link from 'next/link';
import React, { useEffect, useRef } from 'react';
import { useThrottledCallback } from '../../../hooks/use-throttled-callback';

import styles from './product-taxons-navigation.module.scss';

export interface ProductTaxonsNavigationItemProps {
  readonly label: string;
  readonly href: string;
  readonly shallow?: boolean;
  readonly state?: 'inactive' | 'active' | 'emphasized';
  readonly onClick?: React.MouseEventHandler;
}

const Item: React.FC<
  React.PropsWithChildren<ProductTaxonsNavigationItemProps>
> = ({ label, href, shallow, state = 'inactive', onClick }) => {
  const itemRef = useRef<HTMLLIElement>(null);

  const reveal = useThrottledCallback(() => {
    itemRef.current?.scrollIntoView({ inline: 'center', behavior: 'auto' });
  }, 150);

  useEffect(() => {
    if (state === 'active') {
      reveal();
    }
  }, [state, reveal]);

  return (
    <li ref={itemRef} className={styles.item}>
      <Link
        href={href}
        prefetch={false}
        shallow={shallow}
        onClick={onClick}
        className={cn(styles.itemLink, {
          [styles.isActive]: state === 'active',
          [styles.isEmphasized]: state === 'emphasized',
        })}
      >
        {label}
      </Link>
    </li>
  );
};

export interface ProductTaxonsNavigationProps {
  readonly className?: string;
}

const ProductTaxonsNavigationElement: React.FC<
  React.PropsWithChildren<ProductTaxonsNavigationProps>
> = ({ children, className }) => {
  return (
    <nav className={cn(styles.container, className)}>
      <ul className={styles.itemList}>{children}</ul>
    </nav>
  );
};

const ProductTaxonsNavigation = Object.assign(ProductTaxonsNavigationElement, {
  Item,
});

export default ProductTaxonsNavigation;
